<template>
    <section class="exported-horses-page">
        <h2 id="exported-horses" class="print-title">Exported Horses</h2>
        <h3 id="years" class="print-title black-title"> {{ yearsRange }} </h3>
        <p class="text-center"><i>Note: Horses marked * were later re-imported to Libya.</i></p>
        <p class="text-center"><i>Horses temporarily exported for racing or breeding are not listed.</i></p>
    </section>

    <!--    <div class="break-after"/>-->

    <DataTable class="table-horses-universal" :value="exportedHorses" :rowClass="rowClass">
        <Column bodyClass="horse-name" field="name" header="Name"></Column>
        <Column field="lysbNr" header="LYSB.Nr ">
            <template #body="slotProps">
                {{ addBrackets(slotProps.data.lysbNr) }}
            </template>
        </Column>
        <Column field="exportedTo" header="Exported to"></Column>
        <Column field="exportYear" header="Export Year"></Column>
    </DataTable>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {yearFromToMixin} from "@/views/readonly/studbook/util/yearFromToMixin";
import {addBracketsMixin} from "@/views/readonly/studbook/util/addBracketsMixin";

export default {
    name: "ExportedHorsesPage",
    components: {DataTable, Column},
    mixins: [yearFromToMixin, addBracketsMixin],
    props: {
        exportedHorses: Array,
    },
    methods: {
        rowClass() {
            return {
                "table-row": false,
            };
        },
    },
};
</script>

<style lang="scss">
@import "../mixins";

section.exported-horses-page {
    margin-top: 20% !important;
    .p-datatable-thead,
    .p-datatable-tbody {
        @include grid-container(4fr 2fr 2fr 2fr, 0);
    }
}
</style>
